// The company list's selection for "Priradiť vlastníka" (companies/_bulk_owner): pure decisions, tested
// in test/javascript/bulk_select_logic.test.mjs.

const number = (value) => String(value).replace(/\B(?=(\d{3})+(?!\d))/g, " ")

// What the counter says: the ticked rows, or every company of the filter.
export function selectionLabel(ticked, all, cap) {
  if (all) return `Vybrané: všetky firmy filtra (najviac ${number(cap)})`
  return `Vybrané: ${number(ticked)}`
}

// The page's checkbox: checked when every row is, mixed when some are.
export function pageState(ticked, rows) {
  return { checked: rows > 0 && ticked === rows, indeterminate: ticked > 0 && ticked < rows }
}

// Whether the form can be sent.
export function canSubmit(ticked, all) {
  return all || ticked > 0
}
